import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-code",
  "use": "icon-code-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-code\"><path d=\"M378.1 140h130.5v798.3H378.1z m202.7 0h87v798.3h-87z m372.9 0h65.2v798.3h-65.2z m-724.1 0h65.2v798.3h-65.2z m499.6 0h152.2v798.3H729.2zM5.1 140h152.2v798.3H5.1z\" p-id=\"2233\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol